var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { "is-modified": !!_vm.value.length, label: "スキル" } },
    [
      _c(
        "div",
        { staticClass: "boss-layout boss-layout-start boss-layout-gap-large" },
        _vm._l(_vm.options, function (option, i) {
          return _c(
            "label",
            {
              key: i,
              staticClass: "pega-input",
              attrs: { "data-test": "label-" + i },
            },
            [
              _c("input", {
                staticClass: "boss-input-checkbox",
                attrs: { "data-test": "radio-" + i, type: "radio" },
                domProps: {
                  checked: _vm.selectedOption === option.key,
                  value: option.key,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit(
                      "update:selectedOption",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(_vm._s(option.label) + "\n    "),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.skillsMaster.length > 0
        ? _c("select-modal-button", {
            attrs: {
              "master-data": _vm.skillsMasterForShowingArray,
              "experience-range-options": _vm.experienceOptions,
              "default-experience-id": _vm.defaultExperienceId,
              "selected-items": _vm.value.map(function (o) {
                return { id: o.id, experience: o.years.minimum }
              }),
              title: "スキル",
              suffix: "skills",
              "data-test": "modal",
            },
            on: {
              "update-modal-checked-ids": function (value) {
                return _vm.$emit(
                  "input",
                  value.map(function (o) {
                    return {
                      id: o.id,
                      years: {
                        minimum: o.experience
                          ? Number(o.experience)
                          : Number(_vm.defaultExperienceId),
                      },
                    }
                  })
                )
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }